import React, {useCallback, useEffect, useRef, useState} from 'react';
import {FormPageFieldComponentProps} from 'types/formPage';
import {RecordLinksInline} from './RecordLinksInline';
import {withFormikFormControl} from '../../FormikFormControl';
import {useField, useFormikContext} from "formik";
import {fieldQuery} from "../../../helpers/query";
import {AutoComplete} from "primereact/autocomplete";
import {
    insertRecordFormData,
    extract,
    matchRecordField,
    wrapArray,
    isEditingRecord,
    getFormData,
    getItemNames, _isBlank, formatValue, renderValue, FieldTypes, formatValueWithCustom, isDisplayStatus
} from "../../utils";
import _ from "lodash";
import DisplayRendering from "../../DisplayRendering";
import {Button} from "primereact/button";
import RecordSearch from "../../RecordSearch";
import searchElements, {getFilterValues, processControlsWithLookup} from "./search.common";
import {BaseSelect} from "../../SelectOptions/BaseSelect";
import {ProgressSpinner} from "primereact/progressspinner";
import {ProgressBar} from "primereact/progressbar";
import SubForm from "../../SubForm";
import {controlsVisible, CreateNewForm, orderRecords, renderControlButtons} from "../../SubForm/common";
import {useIsOpenControls} from "../../../hooks";
import {useStore} from "../../../@redux";
import {Table} from "../../Table";
import {submitCreateSubForm, submitEditSubForm} from "../../../helpers/formPage/submit";
import {ConfirmDialog} from "primereact/confirmdialog";
import {Dialog} from "primereact/dialog";
import {clearFormData} from "../../../@redux/formData/actions";
import {useDispatch} from "react-redux";
import {clearForm} from "../../../@redux/formPage/actions";
import {Tag} from "primereact/tag";
import cls from "./record-links.module.scss"
import {DataView} from "primereact/dataview";


export const RecordLinks = (props: FormPageFieldComponentProps) => {
    const store = useStore()
    const {name, details, extraConfig, ...rest} = props;
    const {
        display_as = 'table',
        query_once_filter_local = false,
        subform_mode = false,
        controls: controlsDisplay = {},
        display_field,
        force_single,
        delay_save = false
    } = extraConfig
    const controls = {
        dialog: useIsOpenControls(),
        order: useIsOpenControls(),
        create: useIsOpenControls(),
        edit: useIsOpenControls(),
        remove: useIsOpenControls(),
        lookup: useIsOpenControls()
    }
    //modes: display modes dropdown (ie - autocomplete), lookup, inline, slider, slider_form, inline_single, inline_single_edit
    const [records, setRecords] = useState(null)
    const [updatingRecords, setUpdatingRecords] = useState([])
    const [filteredRecords, setFilteredRecords] = useState([])
    const [isInQuery, setInQuery] = useState(false)
    const canForce = ['table', 'autocomplete'].includes(display_as)
    const multiple = (canForce ? !force_single : true) && !_.get(extraConfig, 'options.prefersSingleRecordLink', false)
    const {
        values,
        setFieldValue,
    } = useFormikContext();
    const disabled = isDisplayStatus(extraConfig, 'disable')
    const [field, meta, helpers] = useField(props);
    const remove_before_add = _.get(extraConfig,'remove_before_add', false)
    const minSelected = Math.max(0, _.get(extraConfig,'min') || 0)
    const maxSelected = multiple ? Math.max(0, _.get(extraConfig,'max') || 0) : 1
    const count = wrapArray(field.value).length || 0
    const allow_more = maxSelected ? count < maxSelected : true
    const allow_lookup = !remove_before_add || allow_more
    const openEvent = useRef(null)
    const removeOnSelect = ['autocomplete'].includes(display_as)
    const formMode = isEditingRecord(details.record_id) ? 'edit' : 'create'
    const d = useDispatch()
    const subFormDetails = {...details}
    const getSubFormId = (mode) => {
        const canSubMode = _.get(extraConfig, 'permissions.main.allow_create') && _.get(extraConfig, 'permissions.main.allow_edit')
        const subMode = canSubMode && subform_mode ? mode : 'main'
        return _.get(extraConfig, `subforms.${subMode}`)
    }
    const createFormId = getSubFormId('create')
    const editFormId = getSubFormId('edit')
    const [currRecId, setCurrRecId] = useState("")

    console.log('RecordLink Mode', {multiple,createFormId, editFormId, details, extraConfig, records, value:field.value, count,maxSelected,allow_more,allow_lookup})
    const getRecord = useCallback((idOrRec: string | any, suppliedRecs: any[] | null = null) => {
        if (_.isArray(idOrRec)) return getRecords(idOrRec, suppliedRecs)
        const id = _.isObject(idOrRec as any) ? idOrRec.tableRecordId : idOrRec
        console.log('GETTING RECORD', idOrRec, id, suppliedRecs, records)
        return insertRecordFormData(null, wrapArray(suppliedRecs || records).find(r => r.tableRecordId === id) ?? (_.isObject(idOrRec) ? idOrRec : id), store)
    }, [records, insertRecordFormData, store])

    const getRecords = useCallback((recs, suppliedRecs: any[] | null = null) => {
        return wrapArray(recs).map(rec => getRecord(rec, suppliedRecs))
    }, [records, insertRecordFormData, store])
    const onSaveCreate = useCallback((newRecId) => {
        const newValue = multiple ? wrapArray(field.value).concat(wrapArray(newRecId)) : wrapArray(newRecId)
        helpers.setValue(newValue)
        if (!delay_save) {
            //send to create new record
            setUpdatingRecords(_.uniq([...updatingRecords, newRecId]))
            submitCreateSubForm(createFormId, details.mode, details.instance, getFormData(store, newRecId), (result) => {
                const newUpdates = updatingRecords.filter(ur => ur !== newRecId)
                setUpdatingRecords(newUpdates)
                const newValueAfter = newValue.map(fv => fv === newRecId ? result : fv)
                console.log('submitCreateSubForm', result, newValue, newValueAfter, newRecId)
                helpers.setValue(newValueAfter)
                const newRecords = [...wrapArray(field.value)]
                newRecords.push(result)
                setRecords(newRecords)
                d(clearFormData(newRecId) as any)
                d(clearForm(newRecId) as any)
                console.log('Created Record Complete', newRecId, result.tableRecordId, newValue, newValueAfter, records?.length, newRecords?.length)
            }, error => {
                console.log('Unable to Create Subform', error.message)
            })
        }
    }, [createFormId, helpers, multiple, field, delay_save, store, updatingRecords, records])

    const onSaveEdit = useCallback((dirtyRecs) => {
        if (!delay_save) {
            //send to edit new record
            const dirtyIds = Object.keys(dirtyRecs)
            if (dirtyIds.length) {
                setUpdatingRecords(_.uniq([...updatingRecords, ...dirtyIds]))
                submitEditSubForm(editFormId, details.mode, getFormData(store, dirtyIds), (results) => {
                    const newUpdates = updatingRecords.filter(ur => !dirtyIds.includes(ur))
                    setUpdatingRecords(newUpdates)
                    const newRecords = [...wrapArray(field.value)]
                    for (let rec of results) {
                        const foundIndex = _.findIndex(newRecords, newRec => newRec.tableRecordId === rec.tableRecordId)
                        if (foundIndex >= 0) newRecords[foundIndex] = rec
                        else newRecords.push(rec)
                    }
                    console.log('submitEditSubForm', newRecords, results, records, dirtyIds)
                    helpers.setValue(newRecords)
                    //reset dirty forms
                    for (let dirtyId of Object.values(dirtyIds)) {
                        d(clearFormData(dirtyId) as any)
                        d(clearForm(dirtyId) as any)
                    }
                    setRecords(newRecords)
                }, error => {
                    console.log('Unable to Create Subform', error.message)
                })
            }
        }
    }, [editFormId, multiple, field, delay_save, store, updatingRecords, records])

    const loadOnInit = query_once_filter_local && records === null && ['dropdown', 'multiselect', 'listbox', 'buttons', 'radio', 'checkbox', 'picklist'].includes(display_as)
    const {onQuery} = searchElements(details.path, props, {
        values,
        field,
        setRecords,
        setFilteredRecords,
        setInQuery,
        records,
        filteredRecords,
        isInQuery
    }, removeOnSelect)
    useEffect(() => {
        if (removeOnSelect) {
            onQuery()
        }
    }, [wrapArray(field.value).map(v => v?.tableRecordId).join(',')])
    useEffect(() => {
        if (loadOnInit) onQuery()
    }, [loadOnInit])

    const onLookup = useCallback(() => {
        controls.lookup.handleOpen()
    }, [controls.lookup])
    const onCreate = useCallback(() => {
        controls.create.handleOpen()
    }, [controls.create])
    const onEdit = useCallback(() => {
        setCurrRecId("")
        controls.edit.handleOpen()
    }, [controls.create])
    const onEditRecord = useCallback((idx) => {
        setCurrRecId(idx)
        controls.edit.handleOpen()
    }, [controls.create])
    const onOrder = useCallback(() => {
        controls.order.handleOpen()
    }, [controls.order])

    const recordSearch = (processSelected: (selected: any[]) => void, options: any = {}) => {
        return (
            controls.lookup.isVisible ? <RecordSearch visible={controls.lookup.isVisible} isInQuery={isInQuery}
                                                      onHide={() => controls.lookup.handleClose()}
                                                      field={field} details={{...details, ...(extraConfig || {})}}
                                                      {...extract({
                                                          multiple: multiple,
                                                          allowClickDone: !multiple,
                                                          allowDblClickDone: true,
                                                          allowEmptySelection: true,
                                                          hideInitSelected: false,
                                                          debounceInterval: query_once_filter_local ? 0 : 1000,
                                                      }, options)}
                                                      initSelected={rest.value}
                                                      records={filteredRecords}
                                                      openEvent={openEvent.current}
                                                      onQuery={onQuery}
                                                      onDone={(selected: any[]) => {
                                                          controls.lookup.handleClose()
                                                          console.log("Lookup Form Values", selected)
                                                          processSelected(selected)
                                                      }}
            /> : <></>
        )
    }


    const createControls = (options) => renderControlButtons(controlsVisible(options, extraConfig, formMode), {
        onCreate,
        onOrder,
        onLookup,
        onEdit
    }, processControlsWithLookup(details, extraConfig, store, {allow_more,allow_lookup}))
    const createMissingSub = (mode) => {
        return (<Dialog header="Form Not Ready" visible={true} style={{width: '50vw'}}
                        footer={<Button onClick={() => controls[mode].handleClose()} label={'DONE'}/>}
                        onHide={() => controls[mode].handleClose()}>
            <p>Form Not Configured Yet for {mode.toUpperCase()}</p>
        </Dialog>)
    }
    const createForm = () => (
        controls.create.isVisible ?
            (createFormId ? <CreateNewForm form_id={createFormId} details={subFormDetails} control={controls.create}
                                           extraConfig={extraConfig} onSave={onSaveCreate}/>
                : createMissingSub('create')) : ''
    )
    const editForm = () => (
        controls.edit.isVisible ?
            (editFormId ?
                <SubForm form_id={editFormId} name={name} visible={controls.edit} onClose={onSaveEdit} mode={'edit'}
                         getRecord={getRecord} dialog={true} display_as={'gallery'} controls={controls}
                         value={field.value} details={subFormDetails} extraConfig={extraConfig} initId={currRecId} count={Math.random()}
                         recordSearch={recordSearch}/>
                : createMissingSub('edit')) : ''
    )
    const lookupForm = () => controls.lookup.isVisible ? recordSearch(selected => {

        helpers.setValue(wrapArray(selected))
    }) : ''
    const orderRecs = orderRecords(field.value, controls.order, extraConfig, (newItems) => helpers.setValue(newItems))
    const itemTemplate = (option) => {
        if (!option) {
            return <p/>;
        }
        return <div>{`${option[display_field?.name || 'Name'] || ''}`}</div>;
    };
    console.log('RecordLink', display_as, values, multiple, display_field, filteredRecords)
    if (updatingRecords.length) {
        const {plural} = getItemNames(extraConfig, 'Linked Record')
        return (
            <>
                <ProgressBar mode="indeterminate"/>
                <div className={'flex justify-content-start'}>
                    <div className={'flex justify-content-center w-full'}>Updating {plural}...</div>
                </div>
            </>
        )
    }
    if (display_as === 'autocomplete') {
        return (
            <>
                {createControls({lookup: false, create: true, edit: true, display: false, order: true})}
                <AutoComplete
                    field={display_field?.name}
                    name={name}
                    suggestions={filteredRecords}
                    completeMethod={(event) => {
                        onQuery(event)
                    }}
                    itemTemplate={itemTemplate}
                    selectedItemTemplate={itemTemplate}
                    multiple={multiple}
                    {...extract({
                        dropdown: true,
                        forceSelection: undefined,
                        type: undefined,
                        autoHighlight: undefined,
                        scrollHeight: undefined,
                        dropdownMode: 'current',
                        dropdownAutoFocus: undefined,
                        minLength: undefined,
                        delay: undefined,
                        style: undefined,
                        className: undefined,
                        inputStyle: undefined,
                        inputClassName: undefined,
                        panelClassName: undefined,
                        panelStyle: undefined,
                        placeholder: undefined,
                        readOnly: undefined,
                        maxLength: undefined,
                        size: undefined,
                        dropdownIcon: undefined,
                        removeIcon: undefined,
                    }, extraConfig, rest)}
                    onChange={e => {
                        console.log('On Change Autocomplete', e)
                        rest.onChange(e)

                    }}
                    onBlur={(e) => {
                        if (rest.value && !_.isObject(rest.value)) {
                            helpers.setValue(null)
                        }
                    }}

                />
                {editForm()}
                {createForm()}
                {orderRecs}
            </>
        );
    } else if (display_as === 'lookup') {
        const hasValue = !_isBlank(rest.value)
        console.log('Lookup Render', hasValue, rest.value)
        const {displayRecord = true} = extraConfig
        return (
            <>
                {createControls({lookup: true, create: true, edit: false, display: false, order: true})}
                {displayRecord && hasValue && <DisplayRendering name={name} {...{
                    extraConfig: {
                        state: {
                            showCheck: false,
                            highlight: false,
                            selected: true,
                            showClear: true,
                            onClear: () => helpers.setValue(null)
                        }, render_as: 'record', ..._.get(extraConfig, 'display', {})
                    }, ...rest
                }}/>}
                {editForm()}
                {lookupForm()}
                {createForm()}
                {orderRecs}
            </>
        )
    } else if (display_as === 'table') {
        return <>
            <Table env={'record'} form_id={editFormId} name={name} visible={controls.dialog} onSaveEdit={onSaveEdit}
                   mode='manage' dialog={false} getRecord={getRecord} display_as={'gallery'} controls={{...controls, more:{allow_more,allow_lookup}}}
                   value={field.value} details={details} extraConfig={extraConfig} recordSearch={recordSearch}
                   createForm={createForm}/>
        </>
    } else if (display_as === "simple") {
        const allowEdit = _.get(extraConfig, `permissions.main.allow_edit`)
        const allowRemove = _.get(extraConfig, 'permissions.main.allow_remove')
        const fields = _.get(extraConfig, 'display_fields.fields', []);
        let numCols = extraConfig.number_of_columns;
        let gridCols = `col-${12 / numCols}`
        const separator = extraConfig.simple_separator || " | "


        const itemTemplateAsIs = (record) => {
            return <div className={gridCols}>
                <div className={cls.recordGridItem}>
                    <div className={cls.recordGridItemTop}><DisplayRendering
                        value={fields.map(item => record[item.name])} name={"name"} {...{
                        extraConfig: {
                            divider: separator,
                            inline: true,
                            display_as: display_as,
                        }
                    }} />{allowRemove && <i className="pi pi-times cursor-pointer" onClick={() => {
                        field.value.splice(field.value.indexOf(record), 1);
                        helpers.setValue(field.value)
                    }}></i>}</div>
                </div>
            </div>
        }

        const showOnBasic = fld => {
            return fld.show.list && ![FieldTypes.FT_RECORD_LINKS,FieldTypes.FT_ATTACHMENTS].includes(fld.type)
        }

        const itemTemplateColumns = (record) => {
            const max = Number(`${extraConfig.max_length_field || 0}`)
            let checkMax = val => (_.isString(val) && max && val.length > max) ? val.substring(0,max) + '...' : val
            let value = fields.filter(showOnBasic ).map( fld => formatValueWithCustom('display', checkMax(record[fld.name] || record[fld.id]), fld, details, record )).join(separator)
            console.log("ITEM TEMPLATE COLUMNS", {separator, record, value, fields, max})

            return <div className={gridCols}>
                <div className={cls.recordGridItem}>
                    <div className={cls.recordGridItemTop}><Tag className={allowEdit ? 'cursor-pointer ' : 'opacity-50'}
                                                                value={renderValue(value, {format_as:'html'}) }
                                                                style={{background:"white", color:"black", fontSize:"1rem", fontWeight:"700"}}
                                                                onClick={() => {
                                                                    if (allowEdit) {
                                                                        onEditRecord(record.tableRecordId);
                                                                    }
                                                                }} rounded={false}/>
                        {allowRemove && <i className="pi pi-times cursor-pointer" onClick={() => {
                            field.value.splice(field.value.indexOf(record), 1);
                            helpers.setValue(field.value)
                        }}></i>}</div>
                </div>
            </div>
        }

        const renderAsSimplePills = () => {
            const items = []

            if (wrapArray(field.value).length > 0) {
                field.value.forEach((fieldValue) => {
                    const value = fields.filter(showOnBasic ).map(fld => formatValueWithCustom('display', fieldValue[fld.name], fld, details, fieldValue ) ).join(separator)
                    const maxFieldLen = extraConfig.max_length_field ? extraConfig.max_length_field : 50
                    items.push(<>
                        <Tag className={allowEdit ? 'primary justify-between cursor-pointer ' : 'primary justify-between opacity-50'} style={{fontSize:"1rem", fontWeight:"700"}} onClick={() => {
                            if (allowEdit)  {
                                onEditRecord(fieldValue.tableRecordId);
                            }
                        }}>{value?.length > maxFieldLen ? value.substring(0,maxFieldLen) + "..." : value} </Tag>
                        {allowRemove && <i className="pi pi-times cursor-pointer px-2 " onClick={() => {
                               field.value.splice(field.value.indexOf(fieldValue), 1);
                               helpers.setValue(field.value)}
                           }></i>}
                        </>
                    )

                })
                return items;
            }else return <span>No results found</span>
        }

        return (<>{createControls({lookup: true, create: true, edit: field.value?.length > 0, display: false, order: true})} {editForm()}
            {lookupForm()}
            {createForm()}
            {extraConfig.display_mode === 'columns' ?
                <DataView value={field.value} layout="grid" itemTemplate={itemTemplateColumns}/> : <div>{renderAsSimplePills()} </div>}
        </>)

    } else if (['inline_single', 'inline_single_edit'].includes(display_as)) {
        return <>{editForm()}</>
    } else if (['dropdown', 'multiselect', 'listbox', 'buttons', 'radio', 'checkbox', 'picklist'].includes(display_as)) {
        return query_once_filter_local ?
            (records ?
                <>
                    {createControls({lookup: false, create: true, edit: true, display: false, order: false})}
                    {createForm()}
                    <BaseSelect name={name} multiple={multiple} records={filteredRecords} getRecord={getRecord}
                                extraConfig={{...extraConfig, allow_create: false}} {...rest} />
                    {editForm()}
                </>
                : <ProgressBar mode={'indeterminate'}/>)
            : <h5>This Display Type not supported with large record limits</h5>
    }

    return <DisplayRendering name={name} {...{extraConfig, ...rest}}/>
};

export const RecordLinksFormik = withFormikFormControl()(RecordLinks);

export default RecordLinksFormik;
